import { useAuth } from '../contexts/AuthContext';

/**
 * Agent write-permission gate (UI only — the backend is the real authority; every
 * goal/schedule/approval mutation route 403s a viewer server-side, see DEF-8).
 *
 * Viewers are read-only; everyone else may create/edit/approve. A missing role
 * defaults to writable so a member whose role isn't populated is never locked out
 * of controls they're actually allowed to use.
 */
export function useCanWriteAgent(): boolean {
  const { user } = useAuth();
  return user?.role !== 'viewer';
}
